
import Vue from 'vue';
import InvoiceDisputesTable from '@/components/_InvoiceDisputes/InvoiceDisputesTable.vue';

export default Vue.extend({
	components: {
		InvoiceDisputesTable
	},
	props: {
		visible: { type: Boolean, required: true },
		legalEntity: { type: String, required: true },
		recipient: { type: String, required: true },
		invoices: { type: Array, required: true }
	},
	methods: {
		handleInvoiceDisputesTableChange() {
			this.$emit('change', {});
		},
		handleClose() {
			this.$emit('dialog-close', {});
		}
	}
});
